'use strict';


function AboutCtrl($rootScope, $scope, $sce, objectMakerFactory, appSettings, parameterFactory, parameterNames) {
	$scope.initAboutController = function() {
		$scope.aboutViewControl = objectMakerFactory.viewObjectControlForAbout();
		$scope.aboutViewControl.about = $sce.trustAsHtml(appSettings.getAbout());
		$scope.aboutViewControl.cliet = parameterFactory.getParameter(parameterNames.PRM_NAME_CLIENT).value;
	}
}

AboutCtrl.$inject = ['$rootScope', '$scope', '$sce', 'objectMakerFactory', 'appSettings', 'parameterFactory', 'parameterNames'];
export default AboutCtrl


// WEBPACK FOOTER //
// ./src/app/scripts/controllers/aboutController.js